var wWidth = 0;

$(function(){

  wWidth = $(window).width();
  $(window).resize(function(){
    wWidth = $(window).width();
  });

  /*----------------Bt top------------*/
  $('.bt-top-footer').click(function(){
    $('body, html').animate({scrollTop: 0});
  });
  /*-----------------NAV LANGUE-------------------------*/
  var langueOpenTop = false;
  $('.selected-langue').on( "click", function(e) {
    /*if(wWidth >= 1080){*/
      if(langueOpenTop){
        $(this).removeClass('selected');
        $(this).parent('.multilingue').find('.new-langue').slideUp('fast');
        langueOpenTop = false;
      }
      else{
        $(this).addClass('selected');
        $(this).parent('.multilingue').find('.new-langue').slideDown('fast');
        langueOpenTop = true;
      }
    /*}*/
  }); 

	var timeClick;
  $( ".selected-langue" ).on({
    mouseover: function() {
      stopDetectTime()
    },
    mouseleave: function() {
      if(langueOpenTop == true){
        detectTime();
      }
    }
  });

  function detectTime() {
    timeClick = setTimeout(function(){
      $('.selected-langue').parent('.multilingue').find('.new-langue').slideUp('fast');
      langueOpenTop = false;
    }, 3000);
  }

  function stopDetectTime() {
    clearTimeout(timeClick);
  }
  

    $('body').on({
      mouseenter: function() {
        if(wWidth>= 1024){
          $(this).find('ul').stop().slideDown();
        }
      }, mouseleave: function() {
        if(wWidth>= 1024){
          $(this).find('ul').stop().slideUp();
        }
      }
    }, 'header nav div > ul > li');  

    var openTanNav = false;

    $('body').on({
      click: function(){
        if(wWidth<= 1023){
          if($(this).find('ul').is('.open')){
            $(this).removeClass('open-li');
            $(this).find('ul').slideUp(function(){
              $(this).removeClass('open').parent('li');
            });
          }
          else{
             $('header nav div > ul > li > ul').slideUp();
             $('header nav div > ul > li > ul').removeClass('open-li')
             $(this).addClass('open-li');
            $(this).find('ul').slideDown(function(){
              $('header nav div > ul > li > ul').removeClass('open');
              $(this).addClass('open');
            });
          }
        }
      }
    }, 'header nav div > ul > li');        

/*-----------------NAV MOBILE------------------*/
  var openNavTab = false;
  $('.bt-nav-tab').click(function(){
    if(openNavTab == false){
      $('header .nav').slideDown(function(){
        openNavTab = true;
      });
    }
    else{
      $('header .nav').slideUp(function(){
        openNavTab = false;
      });
    }
  });

  /*--------------Open SEARCH-------------------*/
  $('.bt-search .loupe').click(function(){
    $('.bt-search .form').slideToggle();
  });
  
  /*--------------- Menu Footer-----------------------*/
  $('#footer-nav>li:eq(1)>a').replaceWith('<b>'+$('#footer-nav>li:eq(1)>a').html()+'</b>');
  $('#footer-nav>li:eq(0)>a').replaceWith('<b>'+$('#footer-nav>li:eq(0)>a').html()+'</b>');

  /*-- START RGPD COOKIES CAMPLIANZ -*/
  $('.cmplz-consent-checkbox-ctg').each(function (){
    var cookie = FxyGetCookie($(this).attr('id'));
    var valCookie = cookie.split('=');console.log($(this).attr('id')+$(this).is(":checked")+cookie);
    if (valCookie.indexOf("allow") == 1) {
      //$(this).prop('checked',true);
      if (!$(this).is(":checked")) $(this).trigger('click');
    }else if($(this).attr('data-category') != 'fonctionnel'){
      //$(this).prop('checked', false);
      if ($(this).is(":checked")) $(this).trigger('click');
    }
  });

  $('.cmplz-consent-checkbox-ctg').change(function (){
    if ($(this).is(":checked")) {
      FxySetCookie($(this).attr('id'), 'allow', complianz.cookie_expiry);
      $.each($(this).attr('data-cookies').split('|'), function (index, value) {
        FxySetCookie(value, 'allow', complianz.cookie_expiry);
      });
    } else {
      FxySetCookie($(this).attr('id'), 'deny', complianz.cookie_expiry);
      $.each($(this).attr('data-cookies').split('|'), function (index, value) {
        FxySetCookie(value, 'deny', complianz.cookie_expiry);
      });
    }
  });
  if (!$('#cmplz_marketing_document').is(":checked")) {
    $('input[data-category="marketing-suivi"]').prop('checked',true);
    $('input[data-category="marketing-suivi"]').trigger('change');
  }
  $('#cmplz_marketing_document').change(function (){
      if ($(this).is(":checked")) {
        $('input[data-category="marketing-suivi"]').prop('checked',false);
        $('input[data-category="marketing-suivi"]').trigger('change');
      } else {
        $('input[data-category="marketing-suivi"]').prop('checked',true);
        $('input[data-category="marketing-suivi"]').trigger('click');
      }
  });

  /**
   * Update cookies
   * @param name
   * @param value
   * @param days
   * @constructor
   */
  function FxySetCookie(name, value, days) {
    var secure = ";secure";
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = ";expires=" + date.toGMTString();

    if (window.location.protocol !== "https:") secure = '';

    var domain = cmplzGetCookieDomain();
    if (domain.length > 0) {
      domain = ";domain=." + complianz.cookie_domain;
    }

    document.cookie = name + "=" + value + ";SameSite=Lax" + secure + expires + domain + ";path=/";
  }
  
    
  /*--------------RGPD cookies-------------------*/
	$('.gdpr.gdpr-overlay').after('<div style="" class="gdpr cc-revoke  cc-bottom cc-animate"><span>Cookies: Gérer le consentement</span></div>');
	$('.gdpr.gdpr-privacy-bar .gdpr-buttons .gdpr-preferences').text('Selectionner ses préférences');
	$('.gdpr.gdpr-privacy-bar .gdpr-buttons .gdpr-agreement').text('Refuser tout');
	$('.gdpr.gdpr-privacy-bar .gdpr-buttons').append('<button id="gdpr-accept-all" class="gdpr-accept-all" type="button">Accepter tout</button>');
	$('#gdpr-accept-all').on('click', function(){
		$('input[name="approved_cookies[]"]').each(function(){$(this).prop('checked','checked').trigger('change')});
		$('form.gdpr-privacy-preferences-frm').submit();
	});
	$('.gdpr.cc-revoke, #show-modal-cookies').on('click', function(){
		$('.gdpr .gdpr-buttons .gdpr-preferences').trigger('click');
	});
	
	$('.gdpr-service-header').on('click', function() {
		var item = $(this).next();
		if (item.hasClass("gdpr-service-hidden")) {
			$(this).addClass("gdpr-service-open");
			item.removeClass("gdpr-service-hidden")
		} else {
			$(this).removeClass("gdpr-service-open");
			item.addClass("gdpr-service-hidden")
		}
	});
});